import { render, staticRenderFns } from "./NoteContentBubble.vue?vue&type=template&id=7c95893e&scoped=true&"
import script from "./NoteContentBubble.vue?vue&type=script&lang=js&"
export * from "./NoteContentBubble.vue?vue&type=script&lang=js&"
import style0 from "./NoteContentBubble.vue?vue&type=style&index=0&id=7c95893e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c95893e",
  null
  
)

export default component.exports